<template>
    <img src="@/assets/images/close-btn.svg" class="border-start border-secondary px-3" alt="" />
</template>